import { TableActionsViewButton } from 'common/visualizations/views/agGridReact/TableActionsButton';
import { type TableActionsConfigs } from 'common/visualizations/views/agGridReact/TableActionsButton/types';
import { type ICellRendererParams } from 'ag-grid-community';
import { I18n } from 'common/i18n';

const scope = 'shared.visualizations.panes.presentation.fields.actions';
export function tableActionsColumnDef(tableActionsContext: TableActionsConfigs) {
  return {
    headerName: I18n.t('title', { scope }),
    colId: 'action',
    sortable: false,
    autoHeight: true,
    cellRenderer: (rowParams: ICellRendererParams) => {
      const newTableActions = rowParams.context.newTableActions;
      return TableActionsViewButton({ rowParams, tableActionsContext, newTableActions });
    },
  };
}
